module.exports = __webpack_public_path__ + "static/media/mulher_r2_c2.4cc6b4e7.jpg";